var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allow)?_c('o-tooltip',{attrs:{"text":_vm.label}},[_c('o-panel-link',_vm._b({attrs:{"tag":_vm.component,"path":_vm.path,"slim":_vm.slim}},'o-panel-link',_vm.$attrs,false),[(!_vm.slim)?[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]:_vm._e()],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }